import Modal from "@/components/ui/modal";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FormSuccessHeading } from "@/components/ui/formSuccessHeader";

const queryClient = new QueryClient();

type SuccessModalProps = {
	isOpen?: boolean;
	onClose?: () => void;
	modalTitle?: string;
	title?: string;
	description?: string;
	siteTitle?: string;
	rootElement?: HTMLElement;
	headingRef: React.Ref<HTMLHeadingElement>;
};

export function SuccessModal({
	isOpen,
	onClose,
	modalTitle,
	title,
	description,
	rootElement,
	headingRef,
}: SuccessModalProps) {
	return (
		<Modal
			isOpen={isOpen ?? false}
			onClose={onClose ?? (() => {})}
			title={modalTitle ?? ""}
			rootElement={rootElement}
		>
			<QueryClientProvider client={queryClient}>
				<FormSuccessHeading
					title={title ?? ""}
					description={description ?? ""}
					headingRef={headingRef}
					onClose={onClose ?? (() => {})}
				/>
			</QueryClientProvider>
		</Modal>
	);
}
